import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    // todo: use regular typography here\n    font-size: ", ";\n    line-height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    padding: 0 ", " ", " ", ";\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { makePropList, getPropsBlocker } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { pixelToRem, reset, spacing, typography } from '../../../system/mixins';
import { Button } from '../../Button';
import { fontSize02, fontSize03 } from '../../../tokens';
var propertyList = makePropList(['onApplyValueClick', 'onCancelClick']);
export var DatePickerActionBarRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject(), reset, typography('paragraphMedium'), spacing(4), spacing(4), spacing(4), getComponentOverride('DatePickerActionBar'));
export var DatePickerActionBarButton = styled(Button).attrs({
  tertiary: true
})(_templateObject2(), pixelToRem(fontSize02), pixelToRem(fontSize03));